(function() {
  'use strict';

  var initialized = new WeakSet();

  function initCard(card) {
    if (initialized.has(card)) return;
    initialized.add(card);

    var slides = card.querySelectorAll('.product-card__slide');
    var dots = card.querySelectorAll('.product-card__dot');
    if (slides.length < 2) return;

    var current = 0;
    var count = slides.length;

    function goTo(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      goTo(current + 1);
    }

    function prev(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      goTo(current - 1);
    }

    // Dot click
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });

    // Prev / next arrows (only present when the theme setting is enabled)
    var prevBtn = card.querySelector('.product-card__arrow--prev');
    var nextBtn = card.querySelector('.product-card__arrow--next');
    var arrowsEnabled = prevBtn || nextBtn;
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Swipe gestures — enabled alongside the arrows
    if (arrowsEnabled) {
      var media = card.querySelector('.product-card__media') || card;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var moved = false;
      var THRESHOLD = 40; // px horizontal travel to trigger a slide

      media.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        moved = false;
      }, { passive: true });

      media.addEventListener('touchmove', function(e) {
        if (!tracking) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          moved = true;
        }
      }, { passive: true });

      media.addEventListener('touchend', function(e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) { next(); } else { prev(); }
        }
      }, { passive: true });

      // Stop a swipe from also firing the card link tap
      var link = card.querySelector('.product-card__media');
      if (link) {
        link.addEventListener('click', function(e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.product-card__figure').forEach(initCard);
  }

  // Init on page load
  document.addEventListener('DOMContentLoaded', initAll);

  // Re-init when new content is added (for dynamically loaded sections like recommended products)
  var observer = new MutationObserver(function() {
    initAll();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
